module.exports = __webpack_public_path__ + "static/media/sanitory_bag.6c717482.svg";